import React from "react";

const ServiceHeader = (props) => {
  const { serviceHeadingProps } = props;
  return (
    <section className="py-3 mt-4">
      <div className="container py-3">
        <div className="row text-dark">
          <div className="col-12 text-center p">
            <p className="font-15 let-space-2">
              {serviceHeadingProps.titleLine}
            </p>
            <p className="font-30 font-w800 text-dark">
              {serviceHeadingProps.captionLine}
            </p>
            {serviceHeadingProps.captionLine2 && (
              <h6 className="font-20 font-w500">
                {serviceHeadingProps.captionLine2}
              </h6>
            )}
            {serviceHeadingProps.description != "" && (
              <div className="summary-content mt-5">
                {serviceHeadingProps.description?.map((desc, i) => (
                  <p key={i}>{desc}</p>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHeader;
